<template>
  <div class="question-box">
    <div class="question-title">
      <div class="question-option-fill" style="margin:10px 0 10px -10px">
        <span>{{index+1}}. </span>
        <span class="train-title" v-html="training_title"></span>
        <span class="single-score">({{score}}分)</span>
      </div>
      <div class="train-title" v-html="training_introduce"></div>
    </div>
    <template v-if="training_url">
      <div v-for="(tr,idx) in training_url" class="question-train-url" :key="idx">
        <div class="question-option-video" v-if="jugeMaterialType(tr.name)==='video'">
          <video controls="controls" :src="tr.url"></video>
        </div>
        <div class="question-option-img" v-else-if="jugeMaterialType(tr.name)==='img'">
          <img :src="tr.url" />
        </div>
        <div class="question-option-app" v-else-if="jugeMaterialType(tr.name)==='word'">
          <p>教学文件：</p>
          <span></span><a :href="tr.url" :download="tr.name" target="_blank">{{tr.name}}</a>
        </div>
      </div>
    </template>
    <div class="question-option-material" v-if="materials.length">
      <div class="download-menu">
        <i class="el-icon-download"></i> 参考资料
      </div>
      <div slot="tip" class="el-upload__tip" style="display: inline-block; ">（下载所需资料）</div>
      <ul>
        <li v-for="(item,i) in materials" :key="i">
          <span></span><a :href="item.url" :download="item.name" target="_blank">{{item.name}}</a>
        </li>
      </ul>
      <i class="divider-line"></i>
    </div>

    <div class="question-option-material" v-if="training_tool.length">
      <h2>实训工具</h2>
      <ul>
        <li v-for="(item,i) in training_tool" :key="i">
          <span></span>
          <img :src="item.image" v-if="item.url!=='null'" style="width: 20px;height: 20px;position: relative;top: 3px;" />
          {{item.name}}
        </li>
      </ul>
    </div>
    <div class="show-more" v-if="training_steps.length">
      <span @click="showMore=!showMore" v-if="!showMore">展开更多<i class="el-icon-arrow-right"></i></span>
      <span @click="showMore=!showMore" v-if="showMore">收起<i class="el-icon-arrow-down"></i></span>
    </div>
    <div class="question-desc" v-if="showMore">
      <div class="question-train-steps">
        <h2>实训步骤</h2>
        <div class="train-steps-item" v-for="(item,i) in training_steps" :key="i">
          <span class="steps-num">{{i+1}}</span>
          <div class="item-content" v-html="item.content"></div>
          <img v-for="(img,idx) in item.file" :src="img.url" :key="idx"/>
          <span class="steps-end" v-if="i===training_steps.length-1">END</span>
        </div>
      </div>
    </div>
    <div class="student-answer">
      <i class="divider-line"></i>
      <div class="answer-box">
        <span class="answer-name">{{name}}的答案：<span style="color:red;float:right">+{{student_score}}分</span></span>
        <span v-if="!trainAnswer.content&&!trainAnswer.file.length" style="color:red;">未填写答案</span>
        <template v-if="trainAnswer">
          <div v-html="trainAnswer.content"></div>
          <div class="answer-material" v-if="trainAnswer.file.length">
            <ul class="answer-material-list">
              <li class="material-header">
                <div>
                  <i class="el-icon-paperclip ic"></i>
                  <span>附件（{{trainAnswer.file.length}}）</span>
                </div>
                <div class="download-btn">
                  <!-- <span>下载全部</span> -->
                </div>
              </li>
              <li v-for="(item,i) in trainAnswer.file" :key="i">
                <div>
                  <i class="el-icon-paperclip ic"></i>
                  <span>{{item.name}}</span>
                </div>
                <div class="download-btn">
                  <span v-if="jugeMaterialType(item.name)==='img'"><a :href="item.url" :download="item.name" target="_blank">查看</a></span>
                  <span><a :href="item.url" :download="item.name" target="_blank">下载</a></span>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <div class="teacher-grade">
      <el-form :model="teacher_read" :rules="readRules" ref="readForm" @submit.native.prevent>
        <el-form-item label="教师评分:" prop="score" v-if="type==='contest'">
          <el-input :placeholder="`请评0-`+score+`分`" v-model.trim="teacher_read.score" @blur="postRead" @keyup.enter.native="$event.target.blur"
            :disabled="itemContent.is_view?true:false"></el-input>&nbsp;分
        </el-form-item>
        <el-form-item label="评价星级:" prop="rate" v-if="type==='training'">
          <el-rate v-model="teacher_read.rate" @change="postRead" :disabled="itemContent.is_view?true:false"></el-rate>
          <span style="color:#aaaeb3;">(三星为通过)</span>
        </el-form-item>
        <el-form-item label="教师评语:">
          <el-input type="textarea" :rows="5" placeholder="请输填写评语" v-model="teacher_read.comments" @blur="postRead" @keyup.enter.native="$event.target.blur"
            :disabled="itemContent.is_view?true:false" resize="none"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'name', 'type'],
  data() {
    const validatePassLine = (rule, value, callback) => {
      let max = this.score
      var errors = [];
      if (value > max || value < 0 || value === '') {
        callback(`请输入0-` + max + `以内数值(` + max + `为满分)！`);
      }
      if (!/^[\d\.]*$/.test(value)) {
        callback(`请输入0-` + max + `以内数值(` + max + `为满分)！`);
      }
      if (!/^\d+(\.5?0{0,}|\.0)?$/.test(value)) {
        callback(`小数为0.5倍数！`);
      }
      callback(errors);
    }
    return {
      showMore: false,//展示更多
      training_title: '',//实训标题
      training_introduce: '',//实训简介
      training_url: '',//教学材料
      materials: [],//参考资料
      training_tool: '',//实训工具
      training_steps: [],//实训步骤
      trainAnswer: {
        content: '',
        file: []
      },
      mFiles: [],
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
      teacher_read: {
        score: '',
        comments: '',
        rate: 0,
      },
      readRules: {
        score: [
          { required: true, validator: validatePassLine, trigger: ['blur', 'change'] }
        ],
        rate: [
          { required: true, message: '请评价星级', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    this.teacher_read = {
      score: '',
      comments: '',
      rate: 0
    }
    this.initData()
  },
  methods: {
    initData: function () {
      if (this.itemContent.student_answer) {
        this.trainAnswer = this.itemContent.student_answer
      }
      this.titleId = this.itemContent.id
      this.training_title = this.itemContent.training_title
      this.training_introduce = this.itemContent.training_introduce
      this.training_url = this.itemContent.training_url
      this.materials = this.itemContent.materials
      this.training_tool = this.itemContent.training_tool
      this.training_steps = this.itemContent.training_steps
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
      if (this.itemContent.is_view) {
        this.teacher_read.score = this.itemContent.single_topic_score
        this.teacher_read.comments = this.itemContent.comments
        if (this.type === 'training') {
          this.teacher_read.rate = this.itemContent.single_topic_score
        }
      }
    },
    //教师批阅提交
    postRead: function () {
      if (this.itemContent.is_view) {
        return true
      }
      let subject = {}
      if (this.type === 'contest') {
        subject.score = this.teacher_read.score
      } else if (this.type === 'training') {
        subject.score = this.teacher_read.rate
      }
      subject.comments = this.teacher_read.comments
      subject.title_id = this.titleId
      subject.title_type = 9
      subject.answer = this.trainAnswer
      this.$refs['readForm'].validate((valid) => {
        if (valid) {
          this.$root.$emit('returnRemark', subject)
        } else {
          subject.score = ''
          this.$root.$emit('returnRemark', subject)
        }
      })
    },
    //判断教学材料类型，图片/视频/文件
    jugeMaterialType: function (name) {
      if (!name) return
      let imgArr = ['.jpg', '.jpeg', '.png', '.gif']
      let videoArr = ['.mp4']
      let type = ''
      for (let i = 0; i < imgArr.length; i++) {
        if (name.indexOf(imgArr[i]) > -1) {
          type = 'img'
        }
      }
      if (!type) {
        for (let j = 0; j < videoArr.length; j++) {
          if (name.indexOf(videoArr[j]) > -1) {
            type = 'video'
          }
        }
      }
      if (!type) {
        type = 'word'
      }
      return type
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        str += ' ' + arr[value[i]] + ' '
      }
      return str
    },
  }
}
</script>

<style scoped>
.el-form .el-form-item .el-rate {
  height: 20px;
  line-height: 50px;
}
</style>